(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/create-game/assets/javascripts/product-selection-dropdown.js') >= 0) return;  svs.modules.push('/components/marketplace/create-game/assets/javascripts/product-selection-dropdown.js');
'use strict';

const {
  useContext,
  useCallback,
  useEffect,
  useState
} = React;
const {
  useHistory,
  useParams
} = ReactRouterDOM;
const {
  useSelector,
  useDispatch
} = ReactRedux;
const {
  getProductItems
} = svs.components.marketplaceData.createGame.helpers;
const {
  selectProduct
} = svs.components.marketplaceData.createGame.actions;
const {
  MarketplaceBrand,
  MarketplaceBrandContext
} = svs.components.marketplace.marketplaceBrand;
const {
  resolveProductId,
  getDisplayName
} = svs.utils.products;
const {
  getGame
} = svs.components.marketplaceData.selectors.games;
const {
  DropdownSelectItem,
  DropdownItem,
  DropdownLabel
} = svs.ui.ReactDropdown;
const {
  JackPotAndFunds,
  _formatJackpotAndFunds
} = svs.components.lbUi.jackpotAndFunds.JackPotAndFunds;
const {
  showDialog
} = svs.components.marketplaceData.dialogWrapper.actions;
const ProductSelectionDropdown = _ref => {
  let {
    hasOpenProductOnLoad
  } = _ref;
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    getBrandedDisplayName
  } = useContext(MarketplaceBrandContext);
  const {
    activatedDrawId,
    groupId
  } = useParams();
  const game = useSelector(state => activatedDrawId && getGame(state, {
    activatedDrawId,
    groupId
  }));
  const {
    availableProducts,
    selectedProduct,
    isSelectedDrawClosed
  } = useSelector(state => state.CreateGame || {});
  const {
    draws
  } = useSelector(state => state.Draws);
  const [productItems, setProductItems] = useState();
  useEffect(() => {
    let isMounted = true;
    const setAriaLabels = () => {
      var _ref2, _document$querySelect;
      const dropdownList = document.querySelector('.dropdown-list');
      if (!isMounted || !dropdownList) {
        return;
      }
      dropdownList.setAttribute('aria-label', "Lista med ".concat(productItems.length, " produkter"));
      const dropdownListItems = dropdownList.querySelectorAll('.dropdown-list-item');
      (_ref2 = [...dropdownListItems]) === null || _ref2 === void 0 || _ref2.forEach(listItem => {
        const productItem = productItems === null || productItems === void 0 ? void 0 : productItems.find(_ref3 => {
          var _getDisplayName;
          let {
            item
          } = _ref3;
          const itemId = resolveProductId(item);
          const itemDisplayName = (_getDisplayName = getDisplayName(itemId)) === null || _getDisplayName === void 0 ? void 0 : _getDisplayName.toLowerCase();
          return listItem.innerText.toLowerCase().includes(itemDisplayName);
        });
        if (!productItem) {
          return;
        }
        const {
          disabledReason,
          isDisabled,
          jackpots = [],
          funds = []
        } = productItem || {};
        const productId = resolveProductId(productItem.item);
        const hasJackpotOrFunds = jackpots.length > 0 || funds.length > 0;
        let ariaLabel = getBrandedDisplayName(productId);
        if (disabledReason) {
          ariaLabel += ", ".concat(disabledReason);
        }
        if (hasJackpotOrFunds) {
          const jackpotFunds = _formatJackpotAndFunds({
            productId,
            jackpots,
            funds
          });
          if (jackpotFunds) {
            ariaLabel += ", ".concat(jackpotFunds.text);
          }
        }
        listItem.setAttribute('aria-label', ariaLabel);
        if (isDisabled) {
          listItem.setAttribute('aria-disabled', 'true');
          listItem.classList.add('dropdown-item-disabled');
        } else {
          listItem.removeAttribute('aria-disabled');
          listItem.classList.remove('dropdown-item-disabled');
        }
      });
      (_document$querySelect = document.querySelector('.dropdown-selected .dropdown-label')) === null || _document$querySelect === void 0 || _document$querySelect.setAttribute('id', 'dropdown-label');
    };
    const fetchProductItems = async () => {
      const currentProductItems = await getProductItems({
        allProductNames: availableProducts,
        drawsByProduct: draws
      });
      if (isMounted && (!productItems || JSON.stringify(productItems) !== JSON.stringify(currentProductItems))) {
        setProductItems(currentProductItems);
      }
    };
    fetchProductItems();
    setAriaLabels();
    if (isMounted) {
      if (!hasOpenProductOnLoad) {
        var _document$querySelect2;
        (_document$querySelect2 = document.querySelector('.dropdown-selected')) === null || _document$querySelect2 === void 0 || _document$querySelect2.focus();
      } else {
        var _document$querySelect3;
        (_document$querySelect3 = document.querySelectorAll('.dropdown-list-item')[0]) === null || _document$querySelect3 === void 0 || _document$querySelect3.focus();
      }
    }
    return () => {
      isMounted = false;
    };
  }, [availableProducts, draws, getBrandedDisplayName, productItems, hasOpenProductOnLoad]);
  const onSelectProduct = useCallback(productName => {
    const productIsDisabled = productItems.some(_ref4 => {
      let {
        item,
        isDisabled
      } = _ref4;
      return productName === item && isDisabled;
    });
    const allClosed = productItems.every(_ref5 => {
      let {
        isDisabled
      } = _ref5;
      return isDisabled;
    });
    if (isSelectedDrawClosed && !allClosed) {
      dispatch(showDialog({
        title: 'Spelstopp är för nära',
        text: 'Spelstopp för omgången du valt är för nära. Välj en annan omgång.',
        icon: 'clock'
      }));
    }
    if (!productIsDisabled) {
      const searchParams = new URLSearchParams(history.location.search);
      if (searchParams.has('productName')) {
        searchParams.delete('productName');
        history.replace({
          search: "".concat(searchParams)
        });
      }
      if (searchParams.has('drawNumber')) {
        searchParams.delete('drawNumber');
        history.replace({
          search: "".concat(searchParams)
        });
      }
      dispatch(selectProduct(productName));
    }
  }, [dispatch, history, isSelectedDrawClosed, productItems]);
  if (activatedDrawId) {
    if (!(game !== null && game !== void 0 && game.productId)) {
      return null;
    }
    return React.createElement("div", {
      className: "control-group product-selection-show",
      "data-testid": "product-selection-show"
    }, React.createElement(MarketplaceBrand, {
      className: "product-selection-show-product",
      productId: game.productId,
      size: 100,
      square: true
    }), React.createElement("div", {
      className: "f-medium f-500 margin-top-1"
    }, getBrandedDisplayName(game.productId)));
  }
  if (!productItems) {
    return null;
  }
  return React.createElement("div", {
    className: "control-group",
    "data-testid": "product-selection-choose"
  }, React.createElement(DropdownSelectItem, {
    className: "select-product-list",
    isOpen: hasOpenProductOnLoad,
    onSelect: onSelectProduct,
    v2: true
  }, productItems.map((productItem, index) => {
    const {
      item: productName,
      disabledReason,
      isDisabled,
      jackpots = [],
      funds = []
    } = productItem;
    const productId = resolveProductId(productName);
    const hasJackpotOrFunds = jackpots.length > 0 || funds.length > 0;
    const key = "".concat(productId, "_").concat(index);
    return React.createElement(DropdownItem, {
      key: key,
      name: productName,
      selected: productName === selectedProduct
    }, React.createElement("div", {
      "aria-hidden": "true",
      className: "qa-product-selection-item-wrapper"
    }, React.createElement(MarketplaceBrand, {
      productId: productId,
      size: 100,
      square: true
    }), React.createElement(DropdownLabel, null, React.createElement("div", {
      className: "f-uppercase qa-product-selection-item-name"
    }, getBrandedDisplayName(productId))), Boolean(isDisabled) && React.createElement(DropdownLabel, {
      right: true
    }, React.createElement("div", {
      className: "qa-product-selection-disabled-reason"
    }, disabledReason)), hasJackpotOrFunds && React.createElement(DropdownLabel, {
      right: true
    }, React.createElement("div", {
      className: "product-selection-jackpot-funds"
    }, React.createElement(JackPotAndFunds, {
      funds: funds,
      jackpots: jackpots,
      productId: productId
    })))));
  })));
};
setGlobal('svs.components.marketplace.createGame.ProductSelectionDropdown', ProductSelectionDropdown);

 })(window);